import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import ProjectCard from '../ProjectCard'
import { useFetchProjectsQuery } from '../../services/projectsApi'
import { Project } from '../../types/models/project'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #1a1a1a;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 1.5rem;

    .modal-title {
      color: white;
      font-size: 1.5rem;
      font-weight: 600;
    }

    .btn-close {
      color: white;
      filter: invert(1) grayscale(100%) brightness(200%);
    }
  }

  .modal-body {
    padding: 1.5rem;
    max-height: 70vh;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;
    }
  }
`

const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 1.5rem;
  width: 100%;
  padding: 0.5rem;
`

interface SelectProjectModalProps {
  show: boolean
  onHide: () => void
}

const SelectProjectModal: React.FC<SelectProjectModalProps> = ({ show, onHide }) => {
  const { data: projects, isLoading, isFetching } = useFetchProjectsQuery({})
  const sortedProjects = [...(projects?.projects || [])].sort(
    (a, b) => new Date(b.last_accessed).getTime() - new Date(a.last_accessed).getTime()
  )
  return (
    <StyledModal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Project</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* {isLoading || isFetching ? (
          <div className="text-center text-white">Loading projects...</div>
        ) : ( */}
        <ProjectGrid>
          {sortedProjects?.map((project: Project, index: number) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </ProjectGrid>
        {/* )} */}
      </Modal.Body>
    </StyledModal>
  )
}

export default SelectProjectModal
